import type { JSX, PropsWithChildren } from "react";

import { Skeleton, type SkeletonProps } from "@mantine/core";

export const SkeletonPlaceholder = ({ children, visible, ...rest }: PropsWithChildren<SkeletonProps>): JSX.Element => {
    return visible ? <Skeleton height={"var(--mantine-font-size-md)"} {...rest} /> : <>{children}</>;
};
